import { useEffect, useRef, useState } from "react";
import { toast } from "wc-toast";

export default function PullToRefreshWrapper({ onRefresh, children }) {
  const startY = useRef(null);
  const isPulling = useRef(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    const handleTouchStart = (e) => {
      const scrollContainer = document.querySelector(".mobile-intro-wrapper");
      
      if (scrollContainer && scrollContainer.scrollTop === 0) {
        startY.current = e.touches[0].clientY;
        isPulling.current = true;
      }
    };

    const handleTouchMove = (e) => {
      if (!isPulling.current || isRefreshing) return;

      const currentY = e.touches[0].clientY;
      const distance = currentY - startY.current;


      const scrollContainer = document.querySelector(".mobile-intro-wrapper");
      if (distance < 0 || (scrollContainer && scrollContainer.scrollTop > 0)) {
        isPulling.current = false;
        return;
      }

      if (distance > 80) {
        setIsRefreshing(true);
        isPulling.current = false;

        const toastId = toast.loading("로딩 중...");

        onRefresh().finally(() => {
          toast.dismiss(toastId);
          setIsRefreshing(false);
        });
      }
    };

    const handleTouchEnd = () => {
      isPulling.current = false;
    };

    window.addEventListener("touchstart", handleTouchStart, { passive: true });
    window.addEventListener("touchmove", handleTouchMove, { passive: true });
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [onRefresh, isRefreshing]);

  return <>{children}</>;
}